import { RootState } from "@/app/stores";
import { IListBookingsResponse, listBookings } from "@/shared/api/aviabooking";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchBookings = createAsyncThunk<
    // requestedPage возвращается вместе с ответом, потому что к моменту ответа
    // state.page может быть уже другим (обновление списка после отмены брони меняет
    // страницу на первую). Редьюсер должен решать «заменить или дописать» по той
    // странице, которую реально запрашивали, иначе ответ второй страницы затрёт список.
    IListBookingsResponse & { requestedPage: number },
    void,
    { state: RootState }
>('bookings/fetchBookings', async (_, thunkAPI) => {
    try {
        const { page, limit } = thunkAPI.getState().bookings
        const data = await listBookings(page, limit)
        return { ...data.data, requestedPage: page }
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})